module.exports = __webpack_public_path__ + "static/media/star-small-sparkling.2c2adea8.png";